"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const callableTogglePageLoader = ({ entryVars: { onlyDisable: onlyDisableEntry, lottie, }, processor, }) => {
    if (onlyDisableEntry) {
        processor.root.setIsLoadingPageOpened({ isOpened: false, lottieUrl: undefined });
    }
    else {
        const lottieUrl = typeof lottie === 'string' ? lottie : undefined;
        processor.root.setIsLoadingPageOpened({ isOpened: true, lottieUrl });
    }
};
exports.default = callableTogglePageLoader;
